<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="900px"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <div v-loading="loading">
      <!-- 用户摘要 -->
      <div class="summary_box">
        <div class="summary_grid">
          <div class="summary_item">
            <div class="summary_label">{{ typeName }}累计分红</div>
            <div class="summary_value">{{ summary.total_bonus || '0.00' }}</div>
          </div>
          <div class="summary_item">
            <div class="summary_label">{{ typeName }}待入账</div>
            <div class="summary_value">{{ summary.pending_entry || '0.00' }}</div>
          </div>
          <div class="summary_item">
            <div class="summary_label">{{ typeName }}提现中</div>
            <div class="summary_value">{{ summary.withdrawing || '0.00' }}</div>
          </div>
          <div class="summary_item">
            <div class="summary_label">{{ typeName }}已提现</div>
            <div class="summary_value">{{ summary.withdrawn || '0.00' }}</div>
          </div>
        </div>
      </div>

      <el-table :data="search.table" border style="width: 100%">
        <el-table-column label="用户信息" min-width="200">
          <template #default="{ row }">
            <div class="user_cell">
              <img
                class="user_avatar"
                :src="(row.user && row.user.avatar && row.user.avatar.url) ? row.user.avatar.url : require('@/static/img/people.png')"
                alt=""
              />
              <div class="user_info">
                <div>{{ (row.user && (row.user.true_name || row.user.nick_name)) || "-" }}</div>
                <div class="user_mobile">{{ (row.user && row.user.mobile) || "-" }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="poolprofit_order" label="订单号" align="center" min-width="220">
          <template #default="{ row }">
            {{ row.poolprofit_order || row.order_no || "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="price" label="分红金额" align="center" min-width="120">
          <template #default="{ row }">
            <span class="price_text">{{ row.price >= 0 ? '+' + row.price : row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="entry_status" label="状态" align="center" min-width="100">
          <template #default="{ row }">
            <el-tag v-if="row.entry_status == 1" type="success" size="small">已入账</el-tag>
            <el-tag v-else-if="row.entry_status == 0" type="warning" size="small">待入账</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" align="center" min-width="160">
          <template #default="{ row }">
            {{ row.created_at || "-" }}
          </template>
        </el-table-column>
      </el-table>

      <div class="page_box">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="search.post.page"
          :page-sizes="[15, 30, 50, 100]"
          :page-size="search.post.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="search.total"
        />
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button class="base_but_style" @click="handleClose">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "poolprofitUserDetailModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: [String, Number],
      default: "",
    },
    poolprofitType: {
      type: [String, Number],
      default: 1,
    },
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      search: {
        post: {
          page: 1,
          limit: 15,
        },
        table: [],
        total: 0,
      },
      summary: {},
    };
  },
  computed: {
    title() {
      return this.poolprofitType == 2 ? "合伙人分红明细" : "店长分红明细";
    },
    typeName() {
      return this.poolprofitType == 2 ? "合伙人" : "店长";
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.search.post.page = 1;
        this.search.post.limit = 15;
        this.getList();
      }
    },
    dialogVisible(val) {
      this.$emit("update:visible", val);
    },
  },
  methods: {
    getList() {
      if (!this.userId) return;
      let params = {
        ...this.search.post,
        user_id: this.userId,
        poolprofit_type: this.poolprofitType,
        change_type: 1,
      };
      this.loading = true;
      this.axios
        .get("/api/weishop/admin/plugin/poolprofit/balance/index", { params })
        .then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.search.table = res.data.data || [];
            this.search.total = res.data.total || 0;
            this.setSummary(res.data);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    setSummary(data) {
      if (this.poolprofitType == 2) {
        this.summary = {
          total_bonus: data.partner_total_bonus,
          pending_entry: data.partner_pending_entry,
          withdrawing: data.partner_withdrawing,
          withdrawn: data.partner_withdrawn,
        };
      } else {
        this.summary = {
          total_bonus: data.keeper_total_bonus,
          pending_entry: data.keeper_pending_entry,
          withdrawing: data.keeper_withdrawing,
          withdrawn: data.keeper_withdrawn,
        };
      }
    },
    handleSizeChange(val) {
      this.search.post.limit = val;
      this.search.post.page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.search.post.page = val;
      this.getList();
    },
    handleClose() {
      this.dialogVisible = false;
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.summary_box {
  background: #f8f9fb;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 15px;
  .summary_grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px;
  }
  .summary_item {
    background: #fff;
    border-radius: 4px;
    padding: 12px 15px;
  }
  .summary_label {
    font-size: 13px;
    color: #999;
    margin-bottom: 8px;
  }
  .summary_value {
    font-size: 15px;
    color: #333;
    font-weight: bold;
  }
}
.user_cell {
  display: flex;
  align-items: center;
  padding: 5px 0;
  .user_avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
    object-fit: cover;
  }
  .user_info {
    text-align: left;
    .user_mobile {
      font-size: 12px;
      color: #999;
      margin-top: 4px;
    }
  }
}
.price_text {
  color: #f56c6c;
}
.page_box {
  text-align: right;
  padding: 15px 0 0;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
::v-deep .el-dialog__body {
  padding: 20px 30px 10px !important;
}
</style>
